module.exports = __webpack_public_path__ + "img/cardMessage.1f54940e.png";